export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = useAuthUser()
  const config = useRuntimeConfig()
  const headers = useRequestHeaders(['cookie'])
  // if (import.meta.client) {
  //   console.log('i am on client');
  //   return
  // }
  if (user.value) {
    // console.log('i already have user');
    return;
  } else {
    // console.log('No user detected in global auth check, doing is_logged_in');
  }
  const { data } = await useFetch(`${config.public.apiUrl}/public_api/users/is_logged_in/`, {
    headers: headers,
    mode: "cors",
    credentials: "include"
  })

  if (data.value?.results?.logged_in) {
    // console.log('Found logged in user, fetching profile details and setting state');
    const { data: profile } = await useFetch(`${config.public.apiUrl}/api/users/profile/`, {
      headers: headers,
      mode: "cors",
      credentials: "include"
    })
    if (profile?.value?.results) {
      user.value = profile.value.results
    }
  }

  // console.log('did global user check server side..');
})
